import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  container: {
    minWidth: 320,
    maxWidth: 375,
    minHeight: 280,
    alignSelf: "center",
  },
  inner: {
    alignSelf: "center",
    marginTop: -6,
    borderRadius: constants.radius.view,
    overflow: "auto",
    boxSizing: "border-box",
  },
  item: {
    padding: spacing.xs,
    boxSizing: "border-box",
    cursor: "pointer",
    fontFamily: `"Inter", sans-serif`,
  },
};
